export default __webpack_public_path__ + "static/media/invoice.46d111d5.png";